import { api } from ".";

const basePath = "/dashboard";

type FilterParams = {
  department?: string | null;
  role?: string | null;
};

export const getLiveActivity = async (
  filters: FilterParams,
  otherFilters: any
) => {
  try {
    const { data } = await api.get(`${basePath}/liveActivity`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
        name: otherFilters.name || undefined,
        terminal: otherFilters.terminal || undefined,
        action: otherFilters.action || undefined,
        status: otherFilters.status || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveTotalEmployee = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveTotalEmployee`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveBirthday = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveBirthday`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveAverageWork = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveAverageWork`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveOvertimeCount = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveOvertimeCount`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveTotalTodayEmployee = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveTotalTodayEmployee`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveNotArrived = async (filters: FilterParams, sort: any) => {
  try {
    const { data } = await api.get(`${basePath}/liveNotArrived`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
        sort: sort,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveWeeklyAnalysis = async (
  filters: FilterParams,
  /** 0 = bu hafta, -1 = geçen hafta. Sunucu 0'ın ötesine izin vermiyor. */
  weekOffset = 0
) => {
  try {
    const { data } = await api.get(`${basePath}/liveWeeklyAnalysis`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
        weekOffset,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveTodayShifts = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveTodayShifts`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveTopMenu = async () => {
  try {
    const { data } = await api.get(`${basePath}/liveTopMenu`, {});
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveOfficeDuration = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveOfficeDuration`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

// 1. GÜNCELLEME: period tipine "yearly" eklendi.
export const getLiveWorkDurationReport = async (
  filters: FilterParams,
  period: "daily" | "weekly" | "monthly" | "yearly"
) => {
  try {
    const { data } = await api.get(`${basePath}/liveWorkDurationReport`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
        period,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const getLiveEmployeeDailyDetail = async (
  filters: FilterParams,
  year: number
) => {
  try {
    const { data } = await api.get(`${basePath}/liveEmployeeDailyDetail`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
        year: year,
      },
    });
    
    // EĞER backend direkt datayı dönüyorsa, onu { success: true, data: ... } içine alıyoruz.
    // EĞER zaten success varsa olduğu gibi bırakıyoruz.
    if (data && data.success !== undefined) {
      return data;
    }
    return { success: true, data: data };
  } catch (error) {
    return { success: false, error };
  }
};

/**
 * "Şu an binada" listesi (plan 2.32).
 *
 * ⚠ Bu uç backend'de vardı ama hiçbir istemci onu ÇAĞIRMIYORDU — bu deponun
 * git geçmişinde `liveOccupancy` hiç geçmiyor. Çağrılmadığı için de
 * projeksiyonu eskimiş personel modeline (`employee.department`) göre kalmış
 * ve departman/rol alanları boş dönüyormuş; kimse fark etmemiş. 20 Ağustos
 * 2026'da uç bugünkü modele göre yeniden yazıldı ve buraya bağlandı.
 */
export const getLiveOccupancy = async (filters: FilterParams) => {
  try {
    const { data } = await api.get(`${basePath}/liveOccupancy`, {
      params: {
        department: filters.department || undefined,
        role: filters.role || undefined,
      },
    });
    return data;
  } catch (error) {
    return error;
  }
};
